import { GraphApiCallArgs, GraphApiCallType } from './graph-api-call-args'
import { graphCallWithSsoWrapper } from './generated/graph-api-call-with-sso-wrapper'

export default async function graphRequestAwaitCallback(callType: GraphApiCallType, mailbox: string, payload: any): Promise<any> {
  const request: GraphApiCallArgs = {
    ...payload,
    mailbox: mailbox,
    callType: callType,
  }
  return new Promise((resolve, reject) => {
    // graphCallWithSsoWrapper handles the Graph access token and graph approval popup, and error handling for both
    // once a token is retrieved the actual graph call will be made in graph-api-call-async
    graphCallWithSsoWrapper(resolve, request).catch(reject)
  })
}
